import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { getProductFeatureDescriptionKey } from 'self-service-api/core/utilities/getFeatureDescriptionKey';
import * as ProductLines from 'self-service-api/constants/ProductLines';

const ProductCatalogTableTitle = ({
  featureId,
  productLine,
  showTooltip = true
}) => {
  return /*#__PURE__*/_jsx("p", {
    style: showTooltip ? {
      cursor: 'help'
    } : {},
    children: /*#__PURE__*/_jsx(UITooltip, {
      placement: "right",
      disabled: !showTooltip,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getProductFeatureDescriptionKey(featureId, productLine)
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricing-pages.features.${featureId}.name`
      })
    })
  });
};

ProductCatalogTableTitle.propTypes = {
  featureId: PropTypes.string.isRequired,
  productLine: PropTypes.oneOf(Object.values(ProductLines)).isRequired,
  showTooltip: PropTypes.bool
};
export default ProductCatalogTableTitle;